import styled from "styled-components";

import colors from "core/colors";
import breakpoints from "core/breakpoints";
import { convertPxToRem } from "frontend/components/helpers";

const zIndex = 10000;

export const Underlay = styled.div`
    z-index: ${zIndex};
    width: 100%;
    height: 100%;
    background-color: ${colors.black};
    opacity: 0.6;
    position: fixed;
    top: 0;
    left: 0;
`;

export const Container = styled.section`
    z-index: ${zIndex + 1};
    background-color: ${colors.snow};
    color: ${colors.black};
    position: fixed;
    right: 0;
    top: 0;
    height: 100%;
    box-sizing: content-box;
    width: ${convertPxToRem({ px: 400 })};
    padding: ${convertPxToRem({ px: 40 })} ${convertPxToRem({ px: 66 })};

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        width: ${convertPxToRem({ px: 365 })};
        padding: ${convertPxToRem({ px: 36 })} ${convertPxToRem({ px: 24 })};
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        height: auto;
        top: auto;
        bottom: 0;
        box-sizing: border-box;
        width: 100%;
        padding: ${convertPxToRem({ px: 24 })} ${convertPxToRem({ px: 15 })};
    }
`;
